
export class DialogText {
  static OK = "確定";
  static Cancel = "取消";
  static Yes = "是";
  static No = "否";

  static Delete = "刪除";
  static DangerAction = "執行危險動作";
  static WarningAction = "執行警示動作";
}

export class DialogButtons {
  static OK = { yesText: DialogText.OK, yesButtonProps: {} }
  static OKCancel = { yesText: DialogText.OK, cancelText: DialogText.Cancel }
  static YesNoCancel = { isDangerAction: true, yesText: DialogText.Yes, noText: DialogText.No, cancelText: DialogText.Cancel }
  static YesNo = { isDangerAction: true, yesText: DialogText.Yes, noText: DialogText.No }

  static DeleteCancel: any = { colorMeaning: 'Danger', isDangerAction: true, yesText: DialogText.Delete, cancelText: DialogText.Cancel }
  static DangerCancel: any = { colorMeaning: 'Danger', isDangerAction: true, yesText: DialogText.DangerAction, cancelText: DialogText.Cancel }
  static WarningCancel: any = { colorMeaning: 'Warning', isDangerAction: true, yesText: DialogText.WarningAction, cancelText: DialogText.Cancel }

  static Warning: any = { colorMeaning: 'Warning', isDangerAction: true, yesText: DialogText.OK }
  static Error: any = { colorMeaning: 'Danger', isDangerAction: true, yesText: DialogText.OK }

} 
